// El Alpha OS: sistema operativo del estudiante, planner y materiales.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Alpha OS (Sistema Operativo del Estudiante) ----

export const getAlphaDashboard = async () => (await api.get("/alpha/dashboard")).data;
export const toggleAlphaGoal = async (goalId) => (await api.post("/alpha/goals/toggle", { goal_id: goalId })).data;
export const setAlphaGoals = async (labels) => (await api.put("/alpha/goals", { labels })).data;
export const setAlphaExam = async (payload) => (await api.put("/alpha/exam", payload)).data;
export const getAlphaSkills = async () => (await api.get("/alpha/skills")).data;
export const progressAlphaSkill = async (skillKey, amount = 20) =>
  (await api.post("/alpha/skills/progress", { skill_key: skillKey, amount })).data;

// ---- Alpha OS · Planner de examen ----
//
// Las cuatro de abajo devuelven EL PLAN ENTERO ya actualizado, no un «ok». Es a
// propósito: después de mover un tema la pantalla necesita el estado bueno, y pedirlo en
// una segunda vuelta convertiría el gesto que más se repite —arrastrar— en dos viajes.

export const getExamPlan = async () => (await api.get("/alpha/planner")).data;
export const makeExamPlan = async (payload) => (await api.post("/alpha/planner", payload)).data;
export const getPlannerAsignaturas = async (etapa) =>
  (await api.get("/alpha/planner/asignaturas", { params: etapa ? { etapa } : {} })).data;
export const getPlannerTemario = async (asignatura) =>
  (await api.get("/alpha/planner/temario", { params: { asignatura } })).data;
export const moverTemaPlan = async (temaId, dia, franja) =>
  (await api.post("/alpha/planner/mover", { tema_id: temaId, dia, franja })).data;
export const marcarTemaPlan = async (temaId, hecho) =>
  (await api.post("/alpha/planner/marcar", { tema_id: temaId, hecho })).data;
export const anadirTemaPlan = async (texto) =>
  (await api.post("/alpha/planner/tema", { texto })).data;
export const quitarTemaPlan = async (temaId) =>
  (await api.post("/alpha/planner/tema/quitar", { tema_id: temaId })).data;

// ---- Alpha OS · Materiales del alumno (Oleada D) ----

export const listMaterials = async () => (await api.get("/alpha/materials")).data;
export const uploadMaterial = async (formData) =>
  (await api.post("/alpha/materials/upload", formData, { headers: { "Content-Type": "multipart/form-data" } })).data;
export const generateMaterial = async (id) => (await api.post(`/alpha/materials/${id}/generate`)).data;
export const getMaterial = async (id) => (await api.get(`/alpha/materials/${id}`)).data;
export const deleteMaterial = async (id) => (await api.delete(`/alpha/materials/${id}`)).data;
